var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 64.43,
    viewBox: "0 0 58 64.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_4",
    x: 0,
    y: 0,
    width: 58,
    height: 64.43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#753bbd",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "icon_location_Pricelocq",
    transform: "translate(9 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_PinStation",
    "data-name": "Icon/PinStation"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -7)",
    style: {
      filter: "url(#Union_4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4-2",
    "data-name": "Union 4",
    d: "M16.841 45.126 5.858 34.142A20 20 0 0 1 34.142 5.858a20 20 0 0 1 0 28.284L23.159 45.126a4.476 4.476 0 0 1-6.317 0z",
    transform: "translate(9 7)",
    style: {
      fill: "#753bbd"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(10.864 10.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M55.357 26.068a7.083 7.083 0 0 0-.423-.895l1.987-1.115a9.356 9.356 0 0 1 .56 1.188zm-1-1.763a6.844 6.844 0 0 0-.663-.734l1.578-1.642a8.955 8.955 0 0 1 .88.975zm-1.468-1.4a7.069 7.069 0 0 0-.847-.513l1.041-2.026a9.277 9.277 0 0 1 1.122.68z",
    transform: "translate(-39.719 -19.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M45.417 30.4a5.046 5.046 0 1 1-6.246-3.45 5.046 5.046 0 0 1 6.246 3.45",
    transform: "translate(-31.433 -22.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-2",
    d: "m58.106 38.936 1.5 1.5a9.128 9.128 0 0 0 1.326-6.227l-2.035.326a7.081 7.081 0 0 1-.794 4.4",
    transform: "translate(-42.762 -26.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-2",
    d: "M39.623 34.012a7.074 7.074 0 1 1-1.45-13.188l.536-1.992a9.136 9.136 0 1 0 2.432 16.7z",
    transform: "translate(-27.318 -18.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    className: "cls-2",
    transform: "rotate(-45 18.23 -5.921)",
    d: "M0 0h2.057v10.073H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPin);
export default __webpack_public_path__ + "static/media/selected-pin.49ab64f87348a48d8989bdc49c6fefd6.svg";
export { ForwardRef as ReactComponent };